import { render, staticRenderFns } from "./RecordIcon.vue?vue&type=template&id=4fee60e7&scoped=true&"
import script from "./RecordIcon.vue?vue&type=script&lang=ts&"
export * from "./RecordIcon.vue?vue&type=script&lang=ts&"
import style0 from "./RecordIcon.vue?vue&type=style&index=0&id=4fee60e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fee60e7",
  null
  
)

export default component.exports